import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = {
  key: 0,
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_3 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_4 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_5 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_6 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_7 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_8 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_9 = {
  key: 0,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_11 = {
  key: 1,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_12 = {
  key: 2,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-chart-line" })
], -1 /* HOISTED */)
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end" }
const _hoisted_18 = {
  key: 0,
  class: "ph-bold ph-prohibit fs-12 opacity-50"
}
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end" }
const _hoisted_20 = { class: "form-check form-switch d-inline-block" }
const _hoisted_21 = ["checked"]
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end" }
const _hoisted_23 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-body-tertiary text-end"
}
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end" }
const _hoisted_25 = {
  key: 1,
  class: "shadow-none lh-1 fw-medium text-body-tertiary text-end"
}
const _hoisted_26 = {
  key: 1,
  class: "dropdown position-static"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "data-bs-boundary": "viewport"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1 /* HOISTED */)
const _hoisted_28 = { class: "dropdown-menu" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-pause lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)
const _hoisted_32 = { key: 1 }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)
const _hoisted_35 = {
  key: 2,
  class: "shadow-none lh-1 fw-medium text-body-tertiary text-end"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-chart-line" })
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.therapies && _ctx.therapies.length != 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('feature.therapy.drug')), 1 /* TEXT */),
                _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('feature.therapy.dose')), 1 /* TEXT */),
                _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('form.start_at.label')), 1 /* TEXT */),
                _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('form.end_at.label')), 1 /* TEXT */),
                _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('feature.therapy.prn')), 1 /* TEXT */),
                (_ctx.show_stats)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t(`feature.therapy.intake.$status.${_ctx.IntakeStatus.taken_in_time}`)), 1 /* TEXT */),
                      (_ctx.env === 'sifi_fk' || _ctx.env === 'fungalk')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_9, _toDisplayString(_ctx.$t(`feature.therapy.intake.$status.${_ctx.IntakeStatus.taken_not_in_time}`)), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t(`feature.therapy.intake.$status.${_ctx.IntakeStatus.not_taken}`)), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                (_ctx.show_actions)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_11))
                  : _createCommentVNode("v-if", true),
                (_ctx.therapy_trend_enabled)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_12, [
                      (_ctx.show_overall_trend)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { path: `/patient/${_ctx.patient_id}/therapy/trend`, query: { range_type: 'week', from: _ctx.range.from, to: _ctx.range.to } }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["to"]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("tbody", null, [
              _createCommentVNode(" CENTER ROW "),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.therapies, (therapy) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: therapy.id
                }, [
                  _createElementVNode("td", _hoisted_14, [
                    _createTextVNode(_toDisplayString(therapy.scheme?.drug ?? '') + " ", 1 /* TEXT */),
                    (_ctx.getSchemeRule(therapy.scheme as TherapyScheme)?.intake_per_day !== undefined)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" - " + _toDisplayString(_ctx.$tc('feature.therapy.intakes_per_day',
                                _ctx.getSchemeRule(therapy.scheme as TherapyScheme)!.intake_per_day)), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(therapy.dose), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.YYYYMMDD(therapy.start_at)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_17, [
                    (therapy.previous_stop_at)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                      : _createCommentVNode("v-if", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.YYYYMMDD(therapy.stop_at)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("input", {
                        class: "form-check-input shadow-none",
                        type: "checkbox",
                        role: "switch",
                        checked: therapy.is_prn,
                        disabled: ""
                      }, null, 8 /* PROPS */, _hoisted_21)
                    ])
                  ]),
                  (_ctx.show_stats)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("td", _hoisted_22, _toDisplayString(therapy.taken_in_time), 1 /* TEXT */),
                        (_ctx.env === 'sifi_fk' || _ctx.env === 'fungalk')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(therapy.taken_not_in_time), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("td", _hoisted_24, _toDisplayString(therapy.not_taken), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  (_ctx.show_actions)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                        (_ctx.loading === therapy.id)
                          ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
                              key: 0,
                              class: "h-auto",
                              small: true
                            }))
                          : ((_ctx.is_active_therapy(therapy) || _ctx.is_future_therapy(therapy)))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _hoisted_27,
                                _createElementVNode("ul", _hoisted_28, [
                                  (_ctx.is_active_therapy(therapy))
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                                        _createElementVNode("button", {
                                          class: "dropdown-item d-flex align-items-center",
                                          onClick: ($event: any) => (_ctx.confirmAction(therapy, 'stop'))
                                        }, [
                                          _hoisted_31,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.stop')), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_30)
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  (_ctx.is_future_therapy(therapy))
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                                        _createElementVNode("button", {
                                          class: "dropdown-item d-flex align-items-center",
                                          onClick: ($event: any) => (_ctx.confirmAction(therapy, 'delete'))
                                        }, [
                                          _hoisted_34,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.delete')), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_33)
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ])
                              ]))
                            : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.therapy_trend_enabled)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_35, [
                        (!therapy.is_prn)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { path: `/patient/${_ctx.patient_id}/therapy/${therapy.id}/trend`, query: { range_type: 'week', from: _ctx.YYYYMMDD(therapy.start_at), to: _ctx.YYYYMMDD(therapy.stop_at) } }
                            }, {
                              default: _withCtx(() => [
                                _hoisted_36
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(_component_ConfirmModal, {
      id: `therapies_${_ctx.ids}`,
      onConfirm: _cache[0] || (_cache[0] = ($event: any) => (_ctx.therapyAction())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["id", "title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}